import { render, staticRenderFns } from "./bind-line-tip.vue?vue&type=template&id=12c014a0&scoped=true&"
import script from "./bind-line-tip.vue?vue&type=script&lang=js&"
export * from "./bind-line-tip.vue?vue&type=script&lang=js&"
import style0 from "./bind-line-tip.vue?vue&type=style&index=0&id=12c014a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c014a0",
  null
  
)

export default component.exports